import Apiservice from '@/core/services/api.service';
import { API_URL } from '@/common/config.js'
const apiService = Apiservice;


export default class TopicService {

      #api = null;

      constructor() {
            this.#api = `${API_URL}user/syllabus`;
      }
      paginate(syllabusId,data = null, index=null) {
            let url = `${this.#api}/${syllabusId}/topic`;
            if (data != null && data != undefined && data != "") {
                  var queryString = Object.keys(data).map((key) => {
                        if (data[key] && data[key] != null)
                              return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
                  }).join('&');
                  url = url + '?' + queryString;
            }
            if (index != null)
                  url = url + '?' + "page=" + (index);
            return apiService.get(url);
      }

      update(syllabusId,id, data) {
            let url = `${this.#api}/${syllabusId}/topic/${id}`
            return apiService.put(url, data);
      }

      store(syllabusId,data) {
            let url = `${this.#api}/${syllabusId}/topic`
            return apiService.post(url, data);
      }

      show(syllabusId,id) {
            let url = `${this.#api}/${syllabusId}/topic/${id}`
            return apiService.get(url);
      }
      sort( syllabusId,data) {
            let url = `${this.#api}/${syllabusId}/topic/sort-order`;
            return apiService.post(url, data);
      }


      delete(syllabusId,id) {
            let url = `${this.#api}/${syllabusId}/topic/${id}`
            return apiService.delete(url);
      }
}
